import { render, staticRenderFns } from "./document-folder-edit-modal.vue?vue&type=template&id=12579965&scoped=true"
import script from "./document-folder-edit-modal.vue?vue&type=script&lang=js"
export * from "./document-folder-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./document-folder-edit-modal.vue?vue&type=style&index=0&id=12579965&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12579965",
  null
  
)

export default component.exports